import { z } from "zod";

import { ExperienceDtoSchema } from "../../dtos/experiences";
import { RedirectDtoSchema } from "../../dtos/redirects";
import { castToBool, castToNumber, castToString } from "../../utils";

import {
  AnalyzeContext,
  BaseAnalyticsPayloadSchema,
  CastedTimes,
} from "./base";

// The request from BE > Analytics
export const ExperimentAnalyticsPayloadSchema =
  BaseAnalyticsPayloadSchema.extend({
    resourceType: z.literal("experiences"),
    experienceId: z.string().uuid(),
    testOrdersOnly: castToBool.nullable(),
    maxZScore: castToNumber.nullable(),
    discountIncludeType: z.number().nullable(),
    viewedRedirectOnly: z.boolean().nullable(),
    userBehavior: z.object({
      viewedCheckout: z.boolean().nullable(),
      addedToCart: z.boolean().nullable(),
    }),
    countryCodes: z.string().array(),
    customEvents: z.string().array(),
    excludeIpAddresses: z.string().array(),
  });

export type ExperimentAnalyticsPayloadType = z.infer<
  typeof ExperimentAnalyticsPayloadSchema
>;

// The request from FE > Backend
export const AnalyzeExperimentRequestBodySchema =
  ExperimentAnalyticsPayloadSchema.omit({
    viewedRedirectOnly: true,
    shopifyDomain: true,
    latestRunTs: true,
    timezone: true,
  });

export type AnalyzeExperimentRequestBodyType = z.infer<
  typeof AnalyzeExperimentRequestBodySchema
> &
  CastedTimes;

const AnalyzeExperimentContextSchema = AnalyzeContext.extend({
  experience: ExperienceDtoSchema,
  redirects: RedirectDtoSchema.array(),
});

export type AnalyzeExperimentContextType = z.infer<
  typeof AnalyzeExperimentContextSchema
>;
